import * as React from 'react'
import { FC } from 'react'
import { useGetOne, useRecordContext } from 'react-admin'

interface PageTitleProps {
  resource: string
  source: string
}

const PageTitle: FC<PageTitleProps> = ({ resource, source }) => {
  const record = useRecordContext()
  return record && <span>{record[source] || `${resource} ${record.id}`}</span>
}

export default PageTitle

interface PageTitleWithAssociationProps extends PageTitleProps {
  association: {
    key: string
    name: string
    resource: string
    source: string
  }
}

export const PageTitleWithAssociation: FC<PageTitleWithAssociationProps> = ({ association, resource, source }) => {
  const record = useRecordContext()
  if (!record) return null

  const recordTitle = <PageTitle resource={resource} source={source} />

  return (
    <div>
      <PageTitle resource={association.resource} source={association.source} />: {recordTitle}
    </div>
  )
}
